import { render, staticRenderFns } from "./nodeWrap.vue?vue&type=template&id=22809314&scoped=true&"
import script from "./nodeWrap.vue?vue&type=script&lang=ts&"
export * from "./nodeWrap.vue?vue&type=script&lang=ts&"
import style0 from "./nodeWrap.vue?vue&type=style&index=0&id=22809314&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22809314",
  null
  
)

export default component.exports